/** @format */
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';
import { MarketCode } from '@toucan/client/global/market';
import {
    QuoteExpiryState,
    TransactionByCustomerResponse,
    TransactionVariant,
    transformExpiredQuotes,
    transformTransactionSummary,
} from '@toucan/client/global/transaction';

/**
 * Gets a list of open quotes
 */
export const getOpenQuotes = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        quoteExpiry: QuoteExpiryState.UNEXPIRED,
        hasActiveCollectionConsignment: false,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformTransactionSummary(transaction, [])
    );
    return response.data;
};

/**
 * Gets a list of expired quotes
 */
export const getExpiredQuotes = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        quoteExpiry: QuoteExpiryState.EXPIRED,
        hasActiveCollectionConsignment: false,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformExpiredQuotes(transformTransactionSummary(transaction, []))
    );
    return response.data;
};

export const getTransactions = async (
    market: MarketCode,
    customerId: number,
    length: number,
    start: number
): Promise<TransactionByCustomerResponse> => {
    const request = {
        customerId,
        length,
        start,
        hasActiveCollectionConsignment: true,
        ignoreDeclinedOrCancelled: false,
        ignoreCancelledTransactions: true,
        variant: [
            TransactionVariant.PART_EXCHANGE,
            TransactionVariant.CASH_PURCHASE,
            TransactionVariant.ORDER,
        ],
    };

    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const response = await client.post(
        '/transaction-service/v2/transaction-by-customer/',
        request,
        config
    );

    response.data.data = response.data.data.map((transaction: any) =>
        transformTransactionSummary(transaction)
    );
    return response.data;
};
